<template>

	<button 
	:disabled="disabled"
	@click="onClick" 
	:class="{disabled: disabled}" 
	class="btn btn-pink right">{{ text }}</button>
</template>

<script>
	import store from '@/domain/store.js'
	import bus from '@/bus/event-bus.js'

	export default {
		props: ['click', 'part', 'disabled', 'isLastPage', 'locked'],
		data() {
			return {
				lastPage: false
			}
		},
		mounted() {
			this.lastPage = this.isLastPage
		},
		methods: {
			onClick() {
				if(!this.disabled) {
					if(store.ultimaPart === this.part.Ordem && this.lastPage && !this.locked) {
						bus.$emit('finalizou');
					} else {
						this.click()
					}
				}
			}
		},

		watch: {
			isLastPage(v) {
				this.lastPage = v
			}
		},

		computed: {
			visible() {
				if(this.locked && this.lastPage) return false;
				return true;
			},
			text() {
				return store.ultimaPart === this.part.Ordem && this.lastPage && !this.locked ? "Finish" : "Next"
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/ui/NextButton.vue